import { REGRESSION_IS_RATE, type RegressionSignal } from '@evi/shared';

/**
 * The regression watch's values in Admin's words (pure, so they are tested without the Api client): the stored values
 * (a rate is a share of 1) as a person reads and types them (a rate in percent, starts a day, kWh), and back.
 */

/** "94.5%", "6.0 a day", "19.8 kWh", or "Not on record". */
export function metricText(signal: RegressionSignal, value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return 'Not on record';
  if (REGRESSION_IS_RATE[signal]) return `${Math.round(value * 1000) / 10}%`;
  if (signal === 'starts_per_day') return `${value.toFixed(1)} a day`;
  return `${value.toFixed(1)} kWh`;
}

/** The unit a person types a value in. */
export const metricUnit = (signal: RegressionSignal) => (REGRESSION_IS_RATE[signal] ? '%' : signal === 'starts_per_day' ? 'a day' : 'kWh');

/** A stored value as the text of its input: a rate in percent, blank when not on record. */
export function toInput(signal: RegressionSignal, value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '';
  return REGRESSION_IS_RATE[signal] ? String(Math.round(value * 10_000) / 100) : String(Math.round(value * 100) / 100);
}

/** What a person typed as a stored value: blank is not on record (null), a rate from percent; NaN when it is not a number. */
export function fromInput(signal: RegressionSignal, text: string): number | null {
  const t = text.trim().replace(/%$/, '').trim();
  if (t === '') return null;
  const n = Number(t);
  if (!Number.isFinite(n)) return Number.NaN;
  return REGRESSION_IS_RATE[signal] ? n / 100 : n;
}

/** A threshold's change as a person reads it: points for a rate, a share for an amount. */
export function changeText(signal: RegressionSignal, change: number): string {
  return REGRESSION_IS_RATE[signal] ? `${Math.round(change * 1000) / 10} points` : `${Math.round(change * 100)}% of the baseline`;
}
